var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import BarsItem from "./BarsItem";

var Bars = function (_Component) {
    _inherits(Bars, _Component);

    function Bars() {
        var _temp, _this, _ret;

        _classCallCheck(this, Bars);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getBarGroups = function () {
            var bars = _this.props.bars;


            var groups = {};

            bars.map(function (bar) {
                var x = bar.x,
                    y = bar.y,
                    width = bar.width,
                    data = bar.data;
                var index = data.index;


                if (!groups[index]) {
                    groups[index] = {
                        id: index,
                        x: x,
                        y: y,
                        width: 0,
                        bars: []
                    };
                }

                groups[index].width = groups[index].width + width;
                groups[index].bars.push(bar);
            });

            return Object.values(groups);
        }, _this.getBar = function (bar, index) {
            var groupMode = _this.props.groupMode;
            var width = bar.width,
                x = bar.x;


            if (groupMode === "grouped") {
                width = width + 6 * index;
                x = x - index * 12;
            } else {
                width = width - 12;
                x = x + 6;
            }

            return _extends({}, bar, {
                width: width,
                x: x
            });
        }, _this.renderBar = function (bar, index) {

            //        const barprops = this.getBar(bar, index);

            bar = _extends({}, bar, {
                id: bar.key
            });

            var current = _this.props.current;

            var isCurrent = current && current.id === bar.id;

            return React.createElement(BarsItem, _extends({}, _this.props, {
                bar: bar,
                isCurrent: isCurrent }));
        }, _this.renderGroup = function (group, index) {
            var id = group.id,
                x = group.x,
                y = group.y,
                bars = group.bars;


            var className = "bars  bars--" + id;

            return React.createElement(
                "g",
                { key: index, className: className },
                bars.map(_this.renderBar)
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Bars.prototype.render = function render() {
        var groups = this.getBarGroups();

        console.log('BARS', this.props);

        return React.createElement(
            "g",
            { className: "bars" },
            groups.map(this.renderGroup)
        );
    };

    return Bars;
}(Component);

export default Bars;